import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { IntegrationType } from '../models/create-new-integration.model';
import { getDragonflyState } from '../reducers';

export const getIntegrationManagementCreateNewState = createSelector(
  getDragonflyState,
  (state) => state?.createNewIntegrationManagement,
);

export const getIntegrationTypes = createSelector(
  getIntegrationManagementCreateNewState,
  (state) => state?.types,
);

export const getIntegrationNameSuffix = createSelector(
  getIntegrationManagementCreateNewState,
  (state) => state?.integrationNameSuffix,
);

export const getIntegrationDescriptionSuffix = createSelector(
  getIntegrationManagementCreateNewState,
  (state) => state?.integrationDescriptionSuffix,
);

export const getSelectedIntegrationType = createSelector(
  getIntegrationManagementCreateNewState,
  (state) => state?.selectedIntegrationType,
);

export const getShowCreateNewIntegrationButtonForTypes = createSelector(
  getIntegrationTypes,
  (data) => {
    return (data ?? []).map(
      (t) =>
        t === IntegrationType.ENBOX ||
        t === IntegrationType.NEVERBOUNCE ||
        t === IntegrationType.APIFON_VIBER_SMS ||
        t === IntegrationType.APIFON_SMS ||
        t === IntegrationType.QC_MESSAGE_APP ||
        t === IntegrationType.AWS_SES ||
        t === IntegrationType.ELIQUA_CX ||
        t === IntegrationType.MSTAT_VIBER_SMS_V2,
    );
  },
);

export const getShowDetailsTab = createSelector(
  getIntegrationManagementCreateNewState,
  (state) => state?.showDetailsTab,
);

export const getCreateNewEnabled = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('intergration.action.create') ? true : false,
);
